import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReactMarkdown from 'react-markdown';

const ErrorMessage = ({ dataItem }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                padding: 1,
                justifyContent: 'flex-start',
                position: 'relative',
                marginBottom: 2,
            }}
        >
            <Paper
                elevation={1}
                sx={{
                    padding: 2,
                    borderRadius: 2,
                    flexGrow: 1,
                    backgroundColor: 'grey.A100',
                    color: 'error.dark',
                    width: '100%',
                    wordWrap: 'break-word',
                    position: 'relative',
                    display: "flex",
                    alignItems: 'flex-start',
                    border: "1px solid",
                    borderColor: 'error.main',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
                }}
            >
                <ErrorOutlineIcon
                    fontSize="large"
                    sx={{
                        marginRight: 2,
                        alignSelf: 'flex-start',
                        color: 'error.main',
                        border: "2px solid",
                        borderRadius: '50%',
                        padding: '4px',
                    }}
                />
                <Box
                    sx={{
                        alightItems: 'flex-start',
                        width: '100%',
                        alignSelf: 'flex-start',
                        overflow: "hidden",
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                        Error
                    </Typography>
                    <ReactMarkdown>
                        {dataItem.data}
                    </ReactMarkdown>
                </Box>
            </Paper>
        </Box>
    );
};

export default ErrorMessage;
